import React from 'react';
import styled from 'styled-components';
import EmptyState from '../../../../shared/layout/feedback/EmptyState';

const AdminDataTable = ({ columns = [], rows = [], loading = false, emptyText = 'No data' }) => {
    if (loading) {
        return <TableWrap><EmptyState>Loading...</EmptyState></TableWrap>;
    }

    if (!rows.length) {
        return <TableWrap><EmptyState>{emptyText}</EmptyState></TableWrap>;
    }

    return (
        <TableWrap>
            <StyledTable>
                <thead>
                    <tr>
                        {columns.map((column) => (
                            <th key={column.key}>{column.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.id || JSON.stringify(row)}>
                            {columns.map((column) => (
                                <td key={`${row.id || 'row'}-${column.key}`}>
                                    {column.render ? column.render(row) : row[column.key]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </StyledTable>
        </TableWrap>
    );
};

export default AdminDataTable;

const TableWrap = styled.div`
    border: 1px solid ${({ theme }) => theme.colors.border || '#e5e7eb'};
    border-radius: 12px;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.surface || '#fff'};
`;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;

    th, td {
        text-align: left;
        padding: 0.75rem 0.875rem;
        border-bottom: 1px solid ${({ theme }) => theme.colors.border || '#e5e7eb'};
        vertical-align: top;
    }

    th {
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: ${({ theme }) => theme.colors.textMuted || '#6b7280'};
        background: ${({ theme }) => theme.colors.tableHeaderBg || '#f9fafb'};
    }

    td {
        color: ${({ theme }) => theme.colors.textPrimary || '#111827'};
        font-size: 0.875rem;
    }

    tbody tr:hover {
        background: ${({ theme }) => theme.colors.tableRowHoverBg || '#f8fafc'};
    }

    tbody tr:last-child td {
        border-bottom: none;
    }
`;

